import React, { Component } from 'react';
import { Button, ButtonToolbar, FormGroup, FormControl, ControlLabel, Modal, Form, Radio, HelpBlock } from 'react-bootstrap';

export class PassingTimesForm extends Component {

    render() {
        let { typeOfPass, freqInputError } = this.props;
        let disabled = typeOfPass === 'isFreq' || typeOfPass === 'freq' ? false : true;

        return (
            <Modal show={this.props.show}>
                <Modal.Header>
                    <Modal.Title>
                        Criar Viagem
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={(e) => { e.preventDefault(); this.props.onSave(); }}>
                        <ControlLabel>Tempo de Passagem</ControlLabel>
                        <FormGroup controlId="formFreq" validationState={freqInputError}>

                            <Radio className="form-checkbox" name="Radio" onChange={(e) => this.props.onChangeValue(e, 'isFreq')} >
                                Com base na viagem anterior
                            </Radio>

                            <FormControl
                                disabled={disabled}
                                type="number"
                                min="0"
                                placeholder="Minutos"
                                onChange={(e) => this.props.onChangeValue(e, 'freq')}
                            />
                            {freqInputError !== null
                                ?
                                <HelpBlock> Introduza um valor positivo. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formClean">
                            <Radio className="form-checkbox" name="Radio" onChange={(e) => this.props.onChangeValue(e, 'isClean')} >
                                Sem tempos de passagem definidos
                            </Radio>
                        </FormGroup>
                    </Form>

                    <ButtonToolbar>
                        <Button type="submit" onClick={this.props.onSave}> CRIAR </Button>
                        <Button onClick={this.props.onHide}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}
